import React from 'react';
import Container from '@/components/ui/Container';
import UsersHeader from '@/components/users/UsersHeader';
import ContactsTable from '@/components/contacts/ContactsTable';
import ContactsActions from '@/components/contacts/ContactsActions';
import ContactsModals from '@/components/contacts/ContactsModals';
import useContactsPage from '@/hooks/contacts/use-contacts-page';
import { ContactsPageProps } from '@/types/contacts-types';
import WorkspaceRequired from '@/components/workspace/workspace-required';

/**
 * Contacts page component
 */
const Contacts: React.FC<ContactsPageProps> = () => {
  const {
    // Data
    contacts,
    isLoading,
    isAdmin,
    columnConfig,
    
    // Modal states
    isAddModalOpen,
    isEditModalOpen,
    isColumnModalOpen,
    selectedContact,
    
    // Filter state
    filterOptions,
    
    // Actions
    handleRowClick,
    handleFilterChange,
    openAddModal,
    closeAddModal,
    closeEditModal,
    closeColumnModal,
    updateColumnConfig,
    
    // Table configuration
    columns
  } = useContactsPage();

  return (
    <Container>
      <WorkspaceRequired>
        <UsersHeader 
          isAdmin={isAdmin} 
          onAddUser={openAddModal}
          data-test-id="contacts-header"
        />
        
        <ContactsActions
          filterOptions={filterOptions}
          onFilterChange={handleFilterChange}
          onAddContact={openAddModal}
        />
        
        <ContactsTable
          data={contacts}
          columns={columns}
          isLoading={isLoading}
          onRowClick={handleRowClick}
        />

        <ContactsModals
          isAddModalOpen={isAddModalOpen}
          isEditModalOpen={isEditModalOpen}
          isColumnModalOpen={isColumnModalOpen}
          selectedContact={selectedContact}
          onCloseAddModal={closeAddModal}
          onCloseEditModal={closeEditModal}
          onCloseColumnModal={closeColumnModal}
          onSaveColumnConfig={updateColumnConfig}
          columnConfig={columnConfig}
          tableType="contacts"
        />
      </WorkspaceRequired>
    </Container>
  );
};

export default Contacts; 